export class AdminServiceInfo {
  url: string;
  httpMethod: HttpMethod;
  methodName: string;
  deprecated: boolean;
  description: string;
  query?: string;
  body?: any;
  response?: any;
}

export enum HttpMethod {
  Get = "GET",
  Put = "PUT",
  Post = "POST",
  Delete = "DELETE"
}
